import React from 'react'

import { CreateProfileContainer } from '../../containers/signup/createProfile'

export default function CreateProfile({accessToken, name, email}) {
    return <CreateProfileContainer accessToken={accessToken} name={name} email={email}/>
}
